import { useCallback } from 'react';

import { formatNumber } from 'src/utils/numberFormatter';
import { readableStringFormatter } from 'src/utils/stringFormatter';

//
//

interface TableRowProps {
  key: string;
  co2Kgs: number;
  numberOfContributions: number;
  endOfPeriod?: number;
  contributions?: number;
}

interface CabinClassTableRowProps {
  cabinClass: string;
  distanceCategory: string;
  co2AmountKgs: { value: number; unit: string };
  numberOfPassengers: number;
  numberOfTransactions: number;
  percentageOfTransactions: number;
}

//

export const useReport = () => {
  const tableConfiguration = {
    tableHead: [
      { id: 'date', width: '25%', label: 'Period', align: 'left' },
      { id: 'co2_amount', width: '25%', label: 'Offset amount', align: 'right' },
      { id: 'end_of_period', width: '25%', label: 'End of period total', align: 'right' },
      { id: 'contributions', width: '25%', label: 'Contributions', align: 'right' },
    ],
    tableRow: [
      { id: 'date', align: 'left', renderValue: (v: TableRowProps) => v?.key },
      {
        id: 'co2_amount',
        align: 'right',
        renderValue: (v: TableRowProps) => `${formatNumber(v?.co2Kgs)} kg`,
      },
      {
        id: 'end_of_period',
        align: 'right',
        renderValue: (v: TableRowProps) => `${formatNumber(v?.endOfPeriod)} kg`,
      },
      {
        id: 'contributions',
        align: 'right',
        renderValue: (v: TableRowProps) => formatNumber(v?.numberOfContributions),
      },
    ],
  };

  const popularCabinClassesTableConfig = useCallback(
    (tableName: string) => ({
      tableHead: [
        { id: 'name', width: '20%', label: tableName, align: 'left' },
        { id: 'co2AmountKgs', width: '20%', label: 'Offset amount', align: 'right' },
        { id: 'numberOfPassengers', width: '20%', label: 'Passengers', align: 'right' },
        { id: 'numberOfTransactions', width: '20%', label: 'Transactions', align: 'right' },
        { id: 'percentageOfTransactions', width: '20%', label: 'Percentage', align: 'right' },
      ],
      tableRow: [
        {
          id: 'name',
          align: 'left',
          renderValue: (v: CabinClassTableRowProps) =>
            readableStringFormatter(v?.cabinClass || v?.distanceCategory),
        },
        {
          id: 'co2AmountKgs',
          align: 'right',
          renderValue: (v: CabinClassTableRowProps) =>
            `${formatNumber(v?.co2AmountKgs?.value)} ${v?.co2AmountKgs?.unit?.toLowerCase()}`,
        },
        {
          id: 'numberOfPassengers',
          align: 'right',
          renderValue: (v: CabinClassTableRowProps) => v?.numberOfPassengers,
        },
        {
          id: 'numberOfTransactions',
          align: 'right',
          renderValue: (v: CabinClassTableRowProps) => v?.numberOfTransactions,
        },
        {
          id: 'percentageOfTransactions',
          align: 'right',
          renderValue: (v: CabinClassTableRowProps) => `${v?.percentageOfTransactions}%`,
        },
      ],
    }),
    []
  );

  //

  return {
    tableConfiguration,
    popularCabinClassesTableConfig,
  };
};
